/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react'
import { COLORS } from '../../openingTimeHelpers'
import { useTranslation } from 'react-i18next'
import { LegendColorBox, LegendContainer, LegendItem, LegendItemText } from './LegendParts/LegendParts'

const LegendOverall = () => {
    const [t] = useTranslation()

    return (
      <LegendContainer>
          <span>{t('openings.opening_times.legend.closed')}</span>
          <LegendItem>
              <LegendColorBox css={css`background-color: ${COLORS.RED};`} />
              <LegendItemText>{'\u003C'} 50%</LegendItemText>
          </LegendItem>

          <LegendItem>
              <LegendColorBox css={css`background-color: ${COLORS.ORANGE};`} />
              <LegendItemText>{'\u003C'} 89%</LegendItemText>
          </LegendItem>

          <LegendItem>
              <LegendColorBox css={css`background-color: ${COLORS.LIME};`} />
              <LegendItemText>{'\u003C'} 94%</LegendItemText>
          </LegendItem>

          <LegendItem>
              <LegendColorBox css={css`background-color: ${COLORS.GREEN};`} />
              <LegendItemText>{'\u003E'} 95%</LegendItemText>
          </LegendItem>
          <span>{t('openings.opening_times.legend.open')}</span>
      </LegendContainer>
    )
}

export { LegendOverall }
